<template>
  <panel :title="title" noButton="true" v-has-perms="rolePerm">
    <div>
      <b-form>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.code"
            :external-errors="errors['code']"
            :label-form="'Code' | translate"
            class-form="col-12 mb-2"
            labelColsSm="2"
            labelColsLg="2"
            type="text"
            :value="form.code"
            :disabled="!formEditable"
            @change="$set(form, 'code', $event)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.name"
            :external-errors="errors['name']"
            :label-form="'Name' | translate"
            class-form="col-12 mb-2"
            labelColsSm="2"
            labelColsLg="2"
            type="text"
            :value="form.name"
            :disabled="!formEditable"
            @change="$set(form, 'name', $event)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.description"
            :external-errors="errors['description']"
            :label-form="'Description' | translate"
            class-form="col-12 mb-2"
            labelColsSm="2"
            labelColsLg="2"
            type="text"
            :value="form.description"
            :disabled="!formEditable"
            @change="$set(form, 'description', $event)"
          />
        </b-form-row>
      </b-form>
      <div class="mt-3 f-w-600 d-flex justify-content-end">
      <b-button
        class="mr-3"
        variant="default"
        @click.prevent="formEditable ? cancel() : closeForm()">
        {{ formEditable ? 'Cancel' : 'Close' | translate }}
      </b-button>
      <b-button
        variant="primary"
        v-has-perms="editRolePerm"
        @click.prevent="formEditable ? onSubmit() : makeFormEditable()"
        :disabled="$v.form.$invalid">
        {{ formEditable ? 'Save' : 'Edit' | translate }}
      </b-button>
    </div>
    </div>
  </panel>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import { TYPES as CONTACT_SECURITY_ROLE_TYPES } from './store'

import ThuxDetailPanelMixin from '../../../../components/thux-detail-panel/ThuxDetailPanelMixin'

export default {
  name: 'ContactSecurityRoleEdit',
  mixins: [ThuxDetailPanelMixin],
  data () {
    return {
      pageName: 'Contact security role',
      rolePerm: 'organization_contactsecurityrole_retrieve',
      editRolePerm: 'organization_contactsecurityrole_update'
    }
  },
  computed: {
    ...mapGetters({
      ...CONTACT_SECURITY_ROLE_TYPES.GENERIC.organization.contactsecurityrole.DETAIL.GETTERS
    })
  },
  components: { },
  methods: {
    ...mapActions({
      ...CONTACT_SECURITY_ROLE_TYPES.GENERIC.organization.contactsecurityrole.DETAIL.ACTIONS
    })
  },
  validations: {
    form: {
      code: { required },
      name: { required },
      description: {}
    }
  }
}
</script>
